import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import classNames from "classnames";

import { Manager, Target, Popper } from "react-popper";
import ClickAwayListener from "material-ui/utils/ClickAwayListener";
import Collapse from "material-ui/transitions/Collapse";
import Portal from "material-ui/Portal";
import { MenuItem, MenuList } from "material-ui/Menu";
import Input from "material-ui/Input";
import ArrowDropdown from "../Icons/ArrowDropdown";
import IconButton from "material-ui/IconButton";

const styles = {
  root: {
    width: "100%",
    zIndex: 1,
  },

  textRoot: {
    display: "inline-flex",
    marginTop: 0,
    background: "#FFFFFF",
    boxSizing: "border-box",
    border: "1px solid #D8DBDF",
    borderRadius: "4px",
  },

  textInput: {
    width: "100%",
    minWidth: "50px",
    border: "none",
    appearance: "none", // Remove border in Safari, doesn't seem to break anything in other browsers
  },

  popperClose: {
    pointerEvents: "none",
  },

  dropdown: {
    background: "#FFFFFF",
    border: "1px solid #D8DBDF",
    boxShadow: "0 4px 8px rgba(0,0,0,.12)",
    width: "calc(100% - 24px)",
    boxSizing: "border-box",
    margin: "0px 12px 12px 12px",
    maxHeight: "300px",
    overflowY: "auto",
  },

  item: {
    fontSize: 13,
    borderBottom: "1px solid #D8DBDF",
    "&:hover": {
      backgroundColor: "rgba(26,101,255,.05)",
    },
  },

  popper: {
    zIndex: 10000,
  },
};

class AutoComplete extends React.Component {
  state = {
    inputValue: "",
    isFocused: false,
    open: false,
    options: [],
  };

  componentDidMount() {
    this.setState({
      inputValue: "",
      isFocused: false,
      open: false,
      options: this.props.options,
    });
  }
  /*** Event Handlers ***/

  handleInputChange = (e) => {
    let { options } = this.props;
    let filteredOptions = [];

    if (e.target.value !== "") {
      filteredOptions = options.filter((op) => {
        return op.toLowerCase().includes(e.target.value.toLowerCase());
      });
    } else {
      filteredOptions = options;
    }

    this.setState({
      inputValue: e.target.value,
      open: filteredOptions.length > 0,
      options: filteredOptions,
    });

    if (this.props.onUpdateInput) {
      this.props.onUpdateInput(e);
    }
  };

  handleInputFocus = () => {
    this.setState({
      isFocused: true,
      open: true,
    });
  };

  handleKeyDown = (e) => {
    const enterKeyCode = 13;

    switch (e.keyCode) {
      case enterKeyCode: //Enter key
        if (!!this.props.onEnterKeyDown && this.state.inputValue !== "") {
          this.props.onEnterKeyDown(this.state.inputValue);
          this.setState({
            inputValue: "",
            open: false,
            options: this.props.options,
          });
        }
        break;
      default:
        this.setState({ focusedChip: null });
        break;
    }
  };

  handleToggle = () => {
    if (this.props.onClick) this.props.onClick();
    this.setState({ open: !this.state.open });
  };

  handleClose = (event) => {
    if (this.target.contains(event.target)) {
      return;
    }

    this.setState({ open: false });
  };

  handleClick = (option) => {
    return () => {
      if (this.props.onItemSelected) {
        this.props.onItemSelected(option);
        this.setState({
          inputValue: "",
          open: false,
          options: this.props.options,
        });
      } else {
        this.setState({
          inputValue: option,
          open: false,
          options: [option],
        });
      }
    };
  };

  setInputRef = (node) => {
    this.input = node;
  };

  createMenuItems = () => {
    const { classes } = this.props;
    const { options } = this.state;

    return options.map((op, i) => {
      if (i === options.length - 1) {
        return (
          <MenuItem
            value={op}
            onClick={this.handleClick(op)}
            key={i}
            className={classes.item}
            style={{ border: "none" }}
          >
            {op}
          </MenuItem>
        );
      } else {
        return (
          <MenuItem
            value={op}
            onClick={this.handleClick(op)}
            key={i}
            className={classes.item}
          >
            {op}
          </MenuItem>
        );
      }
    });
  };

  render() {
    const { classes, disabled, InputProps, placeholder, id, popperPlacement } =
      this.props;

    const { open } = this.state;

    const addWidth = 24;
    return (
      <div className={classes.root} style={this.props.style}>
        <Manager>
          <Target>
            <div
              ref={(node) => {
                this.target = node;
              }}
            >
              <Input
                classes={{
                  root: classes.textRoot,
                  input: classes.textInput,
                }}
                id={id}
                value={this.state.inputValue}
                onChange={this.handleInputChange}
                onFocus={this.handleInputFocus}
                onKeyDown={this.handleKeyDown}
                disabled={disabled}
                disableUnderline
                fullWidth={true}
                placeholder={placeholder}
                inputRef={this.setInputRef}
                endAdornment={
                  <IconButton
                    onClick={this.handleToggle}
                    style={{ height: '39px', width: '39px' }}
                  >
                    <ArrowDropdown color="#71737B" />
                  </IconButton>
                }
                {...InputProps}
              />
            </div>
          </Target>
          <Portal>
            <Popper
              placement={popperPlacement}
              eventsEnabled={open}
              className={classNames(
                { [classes.popperClose]: !open },
                classes.popper
              )}
              style={{
                width: this.target ? this.target.clientWidth + addWidth : "unset",
              }}
            >
              <ClickAwayListener onClickAway={this.handleClose}>
                <Collapse
                  in={open}
                  id="menu-list-collapse"
                  style={{ transformOrigin: "0 0 0" }}
                >
                  <div className={classes.dropdown}>
                    <MenuList
                      autoFocus={true}
                      role="menu"
                      style={{ padding: 0 }}
                    >
                      {this.createMenuItems()}
                    </MenuList>
                  </div>
                </Collapse>
              </ClickAwayListener>
            </Popper>
          </Portal>
        </Manager>
      </div>
    );
  }
}

AutoComplete.propTypes = {
  classes: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  action: PropTypes.func.isRequired,
  popperPlacement: PropTypes.string,
  disabled: PropTypes.bool,
  InputProps: PropTypes.array,
  placeholder: PropTypes.string,
  id: PropTypes.string,
  onUpdateInput: PropTypes.func,
  onEnterKeyDown: PropTypes.func,
  onItemSelected: PropTypes.func,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

AutoComplete.defaultValue = {
  popperPlacement: "bottom",
  options: [],
  id: "autocomplete",
  placeholder: "入力してください",
  disabled: false,
  InputProps: [],
};

export default withStyles(styles)(AutoComplete);



// WEBPACK FOOTER //
// ./src/components/common/AutoComplete.jsx